import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("solo-landing-page-footer", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-page-footer"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
    view: {
      onRender({ model }) {
        model.findType("image").forEach(i =>
          i.set({
            src: "/public-files/logo-dark",
            alt: "logo",
            locked: true,
            editable: true,
            selectable: true,
            hoverable: false,
          })
        );
      },
    },
  });

  BlockManager.add("solo-landing-page-footer", {
    ...config,
    label: "Footer",
    content: template,
  });
}
